import React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { Dialog, DialogContent, IconButton, Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import LockIcon from '@material-ui/icons/Lock';

export const showLockUpPopup = () => {
  confirmAlert({
    customUI: ({ onClose }) => (
      <div className="lockup-popup-container">
        <div className="lockup-popup-content">
          {/* Close Button */}
          <IconButton 
            className="lockup-popup-close" 
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>

          {/* Lock Icon */}
          <div className="lockup-popup-icon">
            <LockIcon />
          </div>

          {/* Heading */}
          <h2 className="lockup-popup-heading">This feature is not enabled</h2>

          {/* Description */}
          <p className="lockup-popup-description">
            This feature is part of Snowkap's AI-powered ESG platform. Contact us for a walkthrough of advanced Scope 3 emissions calculation, S&G insights, and data collection through API, and AI based methods. Snowkap also provides AI-assisted reporting across frameworks like BRSR and ESRS, featuring automated data mapping and ready-to-review disclosures. The platform offers a complete suite of assessments, including supplier assessments, materiality assessments, and custom ESG assessments with automated scoring to streamline data collection, evaluate risks, and generate actionable insights. 
          </p>
          <p className="lockup-popup-contact">
            For more information, contact us at{' '}
            <a 
              href="mailto:supportnow@snowkap.com"
              style={{
                color: '#00B8BA',
                textDecoration: 'underline',
                cursor: 'pointer'
              }}
            >
              supportnow@snowkap.com
            </a>{' '}
            or{' '}
            022 40079311
          </p>

          {/* Video Section */}
          {/* <div className="lockup-popup-video">
            <iframe
              width="100%"
              height="200"
              src="https://www.youtube.com/embed/PVzROBUWqRQ?rel=0&showinfo=0&modestbranding=1"
              title="Sustainability Journey Demo"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              style={{
                borderRadius: '12px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
              }}
            ></iframe>
          </div> */}

          {/* Action Buttons */}
          <div className="lockup-popup-actions">
            <Button 
              className="lockup-popup-btn-primary"
              variant="contained"
              onClick={() => {
                window.location.href = 'mailto:supportnow@snowkap.com?subject=Schedule a Demo - Snowkap ESG Platform&body=Hi,%0A%0AI would like to schedule a demo of the Snowkap ESG platform.%0A%0AThank you.';
              }}
            >
              SCHEDULE A DEMO
            </Button>
            
          </div>

          {/* Features */}
          {/* <div className="lockup-popup-features">
            <div className="lockup-popup-feature">
              ✓ BRSR & ESRS compliant
            </div>
            <div className="lockup-popup-feature">
              ✓ AI-powered reporting
            </div>
            <div className="lockup-popup-feature">
              ✓ GRI framework support
            </div>
          </div> */}
        </div>
      </div>
    ),
    overlayClassName: "lockup-popup-overlay"
  });
};

// Alternative Modal version using Material-UI Dialog
export const showLockUpModal = (isOpen, onClose) => (
  <Dialog
    open={isOpen}
    onClose={onClose}
    maxWidth="md"
    fullWidth
    PaperProps={{
      style: {
        borderRadius: '20px',
        padding: '0',
        overflow: 'visible'
      }
    }}
  >
    <DialogContent style={{ padding: 0 }}>
      <div className="lockup-popup-container">
        <div className="lockup-popup-content">
          {/* Close Button */}
          <IconButton 
            className="lockup-popup-close closebtn" 
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>

          {/* Lock Icon */}
          <div className="lockup-popup-icon">
            <LockIcon />
          </div>

          {/* Heading */}
          <h2 className="lockup-popup-heading">This feature is not enabled</h2>

          {/* Description */}
          <p className="lockup-popup-description">
            This feature is part of Snowkap's AI-powered ESG platform. Contact us for a walkthrough of advanced Scope 3 emissions calculation, S&G insights, and data collection through API, and AI based methods. Snowkap also provides AI-assisted reporting across frameworks like BRSR and ESRS, featuring automated data mapping and ready-to-review disclosures. The platform offers a complete suite of assessments, including supplier assessments, materiality assessments, and custom ESG assessments with automated scoring to streamline data collection, evaluate risks, and generate actionable insights. 
          </p>
          <p className="lockup-popup-contact">
            For more information, contact us at{' '}
            <a 
              href="mailto:supportnow@snowkap.com"
              style={{
                color: '#00B8BA',
                textDecoration: 'underline',
                cursor: 'pointer'
              }}
            >
              supportnow@snowkap.com
            </a>{' '}
            or{' '}
            <a 
              href="tel:+912240079311"
              style={{
                color: '#00B8BA',
                textDecoration: 'underline',
                cursor: 'pointer'
              }}
            >
              022 40079311
            </a>
          </p>

          {/* Video Section */}
          {/* <div className="lockup-popup-video">
            <iframe
              width="100%"
              height="200"
              src="https://www.youtube.com/embed/PVzROBUWqRQ?rel=0&showinfo=0&modestbranding=1"
              title="Sustainability Journey Demo"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              style={{
                borderRadius: '12px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
              }}
            ></iframe>
          </div> */}

          {/* Action Buttons */}
          <div className="lockup-popup-actions">
            <Button 
              className="lockup-popup-btn-primary"
              variant="contained"
              onClick={() => {
                window.location.href = 'mailto:supportnow@snowkap.com?subject=Schedule a Demo - Snowkap ESG Platform&body=Hi,%0A%0AI would like to schedule a demo of the Snowkap ESG platform.%0A%0AThank you.';
              }}
            >
              SCHEDULE A DEMO
            </Button>
            
          </div>

          {/* Features */}
          {/* <div className="lockup-popup-features">
            <div className="lockup-popup-feature">
              ✓ BRSR & ESRS compliant
            </div>
            <div className="lockup-popup-feature">
              ✓ AI-powered reporting
            </div>
            <div className="lockup-popup-feature">
              ✓ GRI framework support
            </div>
          </div> */}
        </div>
      </div>
    </DialogContent>
  </Dialog>
);